import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import SiteHeader from '../../components/SiteHeader/SiteHeader';
import styles from './InscriptionPage.module.css';

const API_URL = process.env.REACT_APP_API_URL || '/api';

function InscriptionStep3Page() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');
  const token = searchParams.get('token');
  const waLead = searchParams.get('waLead') || '';
  const careerLabel = searchParams.get('careerLabel') || '';
  const paymentMode = searchParams.get('paymentMode') || '';
  const planLabel = searchParams.get('planLabel') || '';
  const planTotal = searchParams.get('planTotal') ? Number(searchParams.get('planTotal')) : null;
  const planDiscount = searchParams.get('planDiscount') ? Number(searchParams.get('planDiscount')) : 0;

  const [status, setStatus] = useState('verifying'); // 'verifying' | 'success' | 'error'
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (!id || !token) {
      setStatus('error');
      setErrorMessage('El enlace de verificación no es válido.');
      return;
    }

    const verify = async () => {
      try {
        const response = await fetch(`${API_URL}/inscription/verify`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id, token }),
        });

        const data = await response.json();

        if (!response.ok) {
          setErrorMessage(data.message || 'No se pudo verificar el correo.');
          setStatus('error');
          return;
        }

        setStatus('success');
      } catch {
        setErrorMessage('No se pudo conectar con el servidor.');
        setStatus('error');
      }
    };

    verify();
  }, [id, token]);

  return (
    <div className={styles.page}>
      <SiteHeader />

      <main className={styles.main}>
        <img
          className={styles.odmLogo}
          src="/logos/logos_2.png"
          alt="Logo ODM"
          onError={(e) => {
            e.target.src = '/logos/logos_1.png';
          }}
        />
        <div className={styles.titleBlock}>
          <h1 className={styles.pageTitle}>Inscripciones</h1>
          <div className={styles.carreraRow}>
            <span className={styles.carreraLabel}>
              Crea tu inscripción en la carrera de :
            </span>
            <div className={styles.selectWrapper}>
              <div className={styles.carreraReadonly}>
                <span>{careerLabel || 'Carrera seleccionada'}</span>
                <span className={styles.selectChevron} aria-hidden="true">&#8964;</span>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.formCard}>
          {status === 'verifying' && (
            <p className={styles.step2Text}>Verificando tu correo electrónico...</p>
          )}

          {status === 'error' && (
            <>
              <h2 className={styles.step2Title}>Error de verificación</h2>
              <p className={styles.step2Text}>{errorMessage}</p>
            </>
          )}

          {status === 'success' && (
            <>
              <h2 className={styles.step2Title}>¡Correo confirmado!</h2>
              <p className={styles.step2Text}>
                Tu dirección de correo electrónico ha sido verificada correctamente.
              </p>
              <p className={styles.step2Text}>
                Ahora puedes continuar con el siguiente paso del proceso de inscripción.<br />
                Haz clic en "Siguiente paso" para avanzar.
              </p>
              <div className={styles.submitRow}>
                <button
                  type="button"
                  className={styles.submitButton}
                  onClick={() =>
                    navigate(
                      `/inscripcion/paso-4?id=${id}&paymentMode=${encodeURIComponent(paymentMode)}&careerLabel=${encodeURIComponent(careerLabel)}&planLabel=${encodeURIComponent(planLabel)}&planTotal=${planTotal}&planDiscount=${planDiscount}${waLead ? `&waLead=${encodeURIComponent(waLead)}&leadStage=registered` : ''}`
                    )
                  }
                >
                  Siguiente paso
                </button>
              </div>
            </>
          )}
        </div>
      </main>
    </div>
  );
}

export default InscriptionStep3Page;
